import { useCoachPanelContext } from './CoachPanelProvider';
import { CoachPanel } from './CoachPanel';

/**
 * Connects CoachPanel to the context provider.
 * Rendered inside CoachPanelRoot — not used standalone.
 */
export function CoachPanelDrawer() {
  const { isOpen, close } = useCoachPanelContext();

  return (
    <CoachPanel
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
    />
  );
}
